​import { Component, Renderer2 } from '@angular/core';
import { WebviewpagesPage } from '../../shared/webviewpages/webviewpages';
import { ModalController } from 'ionic-angular';
import { ThirdPartyService, SharedService } from 'baseline-lib';
import { thirdparty } from 'baseline-lib';
import { Global } from '../../../global/global';
import { LoginModalPage } from '../../shared/login-modal/login-modal';
import { Subject } from '../../../../node_modules/rxjs';

/**
 * Generated class for the LottoraceComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'thirdpartygames',
  templateUrl: 'thirdpartygames.html'
})
export class ThirdPartyGamesComponent {

  thirdPartyGame : thirdparty;
  httplink:string;
  loginrequired:boolean = false;
  counter:number;
  private _onDestroy = new Subject<void>();

  constructor(public _thirdPartyService : ThirdPartyService,private renderer: Renderer2,
     public globalData:Global, public modalCtrl : ModalController, 
     public _globalData : Global, public _sharedService : SharedService)
  {
    console.log('Hello ThirdPartyGamesComponent Component');
  }

  ngOnDestroy(){
    if(this._thirdPartyService.subscription)
      this._thirdPartyService.subscription.unsubscribe();
    this._onDestroy.next();
    this._onDestroy.complete();
  } 
  
  ngOnInit()
  {
    this.counter = 0;
    if(this.globalData.selectedGameId == 5 || this.globalData.selectedGameId == 9|| this.globalData.selectedGameId == 10){  //casino
      if (!this.globalData.isLoggedIn) {
       
        this._sharedService.loginSubject.subscribe((data) => {
          console.log("Subscriber got data >>>>> "+ data);
          if(data == false){
            this.loginrequired = true;
            if(this.thirdPartyGame){
              this._thirdPartyService.subscription.unsubscribe();
              this.signOutThirdParty();
            }
          }else{
            this.loginrequired = false;
            this.getGameDetails();
            this.subscribe();
          }
        });
        this.getGameDetails();
      }else{
        this.getGameDetails();
        this.subscribe();
    
      }
     
      
    }else{ //  global bet
      this.getGameDetails();
    }
  }

  subscribe(){
    this._thirdPartyService.thirdPartySubject.subscribe(
      res => {
          if(res)
          {
            if (this.globalData.isLoggedIn && this.globalData.authUser){
             this.thirdPartyGame = this._thirdPartyService.selectedGame;
             // this.sanitizeUrl();
              if(this.thirdPartyGame.authenticationRequired && this.thirdPartyGame.bindingUrl)
              {
                this.appendFrametoDiv();
              }
            }
         }
    });
  }

  getGameDetails(){
    this._thirdPartyService.evaluateThirdPartyGame(this.globalData.selectedGameId).subscribe(
      data=>
      {
        if(data)
        {     
          this.thirdPartyGame = data;

            if(data.authenticationRequired){
              if (this.globalData.isLoggedIn && this.globalData.authUser) {

              }else
                {
                  let profileModal = this.modalCtrl.create(LoginModalPage);
                  profileModal.present();   
                  return;
                }   
            }
  
              if(data.responseObj.error)
              {
                this._thirdPartyService._sharedService.openLogin.next(true);
              }
              else
              {
                if(data.embedded)
                {
                  // if(data.additionalScript){
                  //   // this.addJsToElement('https://westernlotto-test.virtual-horizon.net/responsive/js/widgetIntegration.nocache.js').onload = () => {
                  //   //   //loadGlobal(data.bindingUrl);
                  //   // };
                  // } 
                  if(this.thirdPartyGame.bindingUrl)
                    this.appendFrametoDiv();
                }
                else{
                  this.httplink = this._thirdPartyService.selectedGame.bindingUrl;
                  let profileModal = this.modalCtrl.create(WebviewpagesPage, { url: this.httplink });
                  profileModal.present();
                }

                if (this.thirdPartyGame.sessionExpiry) {
                  this._thirdPartyService.checkExpiry(this.thirdPartyGame);
                }
              
            }
        }            
      });
  }

  addJsToElement(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  appendFrametoDiv()
  {
    this.counter++;
    var div= '<iframe id="thirdPartyFrame" width="96%" height="680" scrolling="yes" class="iframe hidden-xl-up hidden-lg-up hidden-md-up" src="'+this.thirdPartyGame.bindingUrl+'"></iframe>';
    if(document.getElementById("globalbetdiv") != null && this.counter == 1){
    document.getElementById('globalbetdiv').innerHTML += div;
    }
  }

  signOutThirdParty() {

    if (this.thirdPartyGame.signOutUrl && this.thirdPartyGame.thirdpartyAuthResp){
      this._thirdPartyService.signOutThirdParty().subscribe(data => {
        this.getGameDetails();
      }
      , error => {
        console.log(error);
      });
    }else
      this.getGameDetails();
  }
}




// WEBPACK FOOTER //
// ./src/app/thirdpartygames/thirdpartygames/thirdpartygames.ts